var Base = require('_js/base');

function FrontPageCarousel() {
  this.init();
}

FrontPageCarousel.prototype = new Base();

FrontPageCarousel.prototype.init = function() {
  var $carousel = $('.frontpage-campaign-carousel'),
    $slide = $carousel.find('li'),
    $indicator = $('[data-slide-number]'),
    $slideId = $('[data-slide-id]'),
    $nextBtn = $('[data-next-slide]'),
    $prevBtn = $('[data-prev-slide]'),
    numberSlides = $slide.length,
    timeInterval = $('[data-slide-time-interval]').data('slide-time-interval'),
    intervalObj = null;

  $indicator.on('click', function(e) {
    e.preventDefault();
    $indicator.removeClass('is-active');

    if (!$(this).hasClass('is-active')) {
      $(this).addClass('is-active');
    }
    var id = $(this).data('slide-number');
    $.each($slide, function() {
      var $this = $(this);
      if ($this.data('slide-id') === id) {
        if (!$this.hasClass('is-visible')) {
          $slide.removeClass('is-visible');
          $this.addClass('is-visible');
        }
      }
    });
  });

  $nextBtn.on('click', function(e) {
    e.preventDefault();
    stopAutoSlider();
    showNextSlide();
  });

  $prevBtn.on('click', function(e) {
    e.preventDefault();
    stopAutoSlider();
    var $activeSlide = $slide.filter('.is-visible'),
      $activeId = $activeSlide.data('slide-id');

    if ($activeId <= 1) {
      $slide.last().addClass('is-visible');
      $activeSlide.removeClass('is-visible');
    } else {
      $activeSlide.prev($slideId).addClass('is-visible');
      $activeSlide.removeClass('is-visible');
    }

    setStateIndicator();
  });

  function stopAutoSlider() {
    if (intervalObj !== null) {
      clearInterval(intervalObj);
    }
  }

  function setStateIndicator() {
    var $currentId = $slide.filter('.is-visible').data('slide-id'),
      $indicators = $('.frontpage-campaign-indicator a');

    $indicators.removeClass('is-active');

    $.each($indicators, function() {
      var slidenumber = $(this).data('slide-number');

      if (slidenumber === $currentId) {
        $(this).addClass('is-active');
      }
    });
  }

  function loopCarousel() {
    if (timeInterval < 1000) {
      return;
    }

    intervalObj = setInterval(function() {
      showNextSlide();
    }, timeInterval);
  }

  loopCarousel();

  function setPosIndicators() {
    var $indicator = $('.frontpage-campaign-indicator'),
      $indicatorW = $indicator.width() / 2;

    $indicator.css('margin-left', '-' + $indicatorW + 'px');
  }

  setPosIndicators();

  function showNextSlide() {
    var $activeSlide = $slide.filter('.is-visible'),
      $activeId = $activeSlide.data('slide-id');

    if ($activeId < numberSlides) {
      $activeSlide.next($slideId).addClass('is-visible');
      $activeSlide.removeClass('is-visible');
    } else if ($activeId >= numberSlides) {
      $slide.first().addClass('is-visible');
      $activeSlide.removeClass('is-visible');
    }

    setStateIndicator();
  }
};
module.exports = FrontPageCarousel;
